import { ITranslations } from 'types/common';
import { BrandsCataloguesTableTransFields } from './types';
import en from 'translations/en/brandsCataloguesTable.json';
import pl from 'translations/pl/brandsCataloguesTable.json';
import sl from 'translations/sl/brandsCataloguesTable.json';

export const brandsCataloguesTableTranslations: ITranslations<BrandsCataloguesTableTransFields> = {
  name: 'brandsCataloguesTable',
  en,
  pl,
  sl,
};
